import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ServerService } from '../service/server.service';
import { ToastController,NavController,Platform,LoadingController,AlertController } from '@ionic/angular';
import { SocialSharing } from '@awesome-cordova-plugins/social-sharing/ngx';
import {Constant} from "../shared/model/Constant";

@Component({
  selector: 'app-payment',
  templateUrl: './payment.page.html',
  styleUrls: ['./payment.page.scss'],
})

export class PaymentPage implements OnInit {

  data:any;
  text:any;
  constructor(private socialSharing: SocialSharing,public alertController: AlertController,private route: ActivatedRoute,public server : ServerService,public toastController: ToastController,private nav: NavController,public loadingController: LoadingController){

  this.data = JSON.parse(localStorage.getItem(Constant.userData));
  this.text = JSON.parse(localStorage.getItem(Constant.appText));

  }

  ngOnInit()
  {
  }


  async save(data)
  {
    const loading = await this.loadingController.create({
      message: '',
      spinner : 'bubbles',
      duration:3000
    });
    await loading.present();

    this.server.savePaymentgateway(data).subscribe((response:any) => {

     this.presentToast(this.text.update_success);

     this.nav.navigateBack('/account');

    localStorage.setItem(Constant.userData,JSON.stringify(response.user));

    loading.dismiss();

    });
  }

  async presentToast(txt) {
    const toast = await this.toastController.create({
      message: txt,
      duration: 3000,
      position : 'top',
      mode:'ios',
      color:'dark'
    });
    toast.present();
  }
}
